import axios from './axios';

export const getAgents = async () => {
  const response = await axios.get('/superadmin/agents');
  return response.data;
};

export const getSubadmins = async () => {
  const response = await axios.get('/superadmin/subadmins');
  return response.data;
};

export const getCAs = async () => {
  const response = await axios.get('/superadmin/cas');
  return response.data;
};

export const getCustomers = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await axios.get(`/superadmin/customers${queryString ? `?${queryString}` : ''}`);
  return response.data;
};

export const getPayments = async () => {
  const response = await axios.get('/superadmin/payments');
  return response.data;
};

export const getDashboardStats = async () => {
  const response = await axios.get('/superadmin/dashboard-stats');
  return response.data;
};

export const toggleAgentVerification = async (agentId) => {
  const response = await axios.put(`/superadmin/agents/${agentId}/verify`);
  return response.data;
};

export const adjustAgentWallet = async (agentId, amount) => {
  const response = await axios.put(`/superadmin/agents/${agentId}/wallet`, { amount });
  return response.data;
};

export const toggleAgentDownloadStatus = async (agentId) => {
  const response = await axios.put(`/superadmin/agents/${agentId}/download-status`);
  return response.data;
};

export const toggleAgentCustomerTypePermission = async (agentId) => {
  const response = await axios.put(`/superadmin/agents/${agentId}/customer-type-permission`);
  return response.data;
};

export const createSubadmin = async (subadminData) => {
  const response = await axios.post('/superadmin/subadmins', subadminData);
  return response.data;
};

export const updateSubadmin = async (subadminId, subadminData) => {
  const response = await axios.put(`/superadmin/subadmins/${subadminId}`, subadminData);
  return response.data;
};

export const deleteSubadmin = async (subadminId) => {
  const response = await axios.delete(`/superadmin/subadmins/${subadminId}`);
  return response.data;
};

export const getSubadminPermissions = async (subadminId) => {
  const response = await axios.get(`/superadmin/subadmins/${subadminId}/permissions`);
  return response.data;
};

export const updateSubadminPermissions = async (subadminId, permissions) => {
  const response = await axios.put(`/superadmin/subadmins/${subadminId}/permissions`, { permissions });
  return response.data;
};

export const getSubadminPassword = async (subadminId) => {
  const response = await axios.get(`/superadmin/subadmins/${subadminId}/password`);
  return response.data;
};

export const duplicateSubadmin = async (subadminId, username, password) => {
  const response = await axios.post(`/superadmin/subadmins/${subadminId}/duplicate`, { username, password });
  return response.data;
};

export const toggleSubadminStatus = async (subadminId) => {
  const response = await axios.put(`/superadmin/subadmins/${subadminId}/status`);
  return response.data;
};

export const toggleSubadminRejectPermission = async (subadminId) => {
  const response = await axios.put(`/superadmin/subadmins/${subadminId}/reject-permission`);
  return response.data;
};

export const toggleCaRejectPermission = async (caId) => {
  const response = await axios.put(`/superadmin/cas/${caId}/reject-permission`);
  return response.data;
};

export const toggleCaHistoryPermission = async (caId) => {
  const response = await axios.put(`/superadmin/cas/${caId}/history-permission`);
  return response.data;
};

export const createCA = async (name, username, email, mobile_no, password) => {
  const response = await axios.post('/superadmin/cas', { name, username, email, mobile_no, password });
  return response.data;
};

export const updateCA = async (caId, name, username, email, mobile_no, password) => {
  const response = await axios.put(`/superadmin/cas/${caId}`, { name, username, email, mobile_no, password });
  return response.data;
};

export const deleteCA = async (caId) => {
  const response = await axios.delete(`/superadmin/cas/${caId}`);
  return response.data;
};

export const toggleCAStatus = async (caId) => {
  const response = await axios.put(`/superadmin/cas/${caId}/status`);
  return response.data;
};

export const updateAgent = async (agentId, agentData) => {
  const formData = new FormData();
  Object.keys(agentData).forEach(key => {
    // Only append if value is not null/undefined
    if (agentData[key] !== null && agentData[key] !== undefined) {
      formData.append(key, agentData[key]);
    }
  });

  const response = await axios.put(`/superadmin/agents/${agentId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateCustomer = async (customerId, customerData) => {
  const formData = new FormData();
  Object.keys(customerData).forEach(key => {
    if (customerData[key] !== null && customerData[key] !== undefined) {
      if (key === 'profile_photo' || key.startsWith('attachments_')) {
        if (customerData[key] instanceof File) {
          formData.append(key, customerData[key]);
        } else {
          formData.append(key, customerData[key]);
        }
      } else {
        formData.append(key, customerData[key]);
      }
    }
  });

  const response = await axios.put(`/superadmin/customers/${customerId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Get customer form fields
export const getCustomerFormFields = async () => {
  const response = await axios.get('/superadmin/customer-form-fields');
  return response.data;
};

// Update customer form field settings
export const updateCustomerFormField = async (id, settings) => {
  const response = await axios.put(`/superadmin/customer-form-fields/${id}`, settings);
  return response.data;
};

// Get customer form fields for agents (public endpoint)
export const getCustomerFormFieldsPublic = async () => {
  const response = await axios.get('/superadmin/customer-form-fields/public');
  return response.data;
};

// Get all ITRs
export const getITRs = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await axios.get(`/superadmin/itrs${queryString ? `?${queryString}` : ''}`);
  return response.data;
};

// Get customers for allotment
export const getCustomersForAllotment = async () => {
  const response = await axios.get('/superadmin/customers-for-allotment');
  return response.data;
};

// Allot customers to subadmin
export const allotCustomersToSubadmin = async (subadminId, customerIds) => {
  const response = await axios.post('/superadmin/subadmins/allot-customers', { subadminId, customerIds });
  return response.data;
};

export const getAgentPassword = async (agentId) => {
  const response = await axios.get(`/superadmin/agents/${agentId}/password`);
  return response.data;
};

export const updateAgentPassword = async (agentId, password) => {
  const response = await axios.put(`/superadmin/agents/${agentId}/password`, { password });
  return response.data;
};

// Remove customer allotment from subadmin
export const removeCustomerAllotment = async (subadminId, customerId) => {
  const response = await axios.delete(`/superadmin/subadmins/${subadminId}/allot-customers/${customerId}`);
  return response.data;
};

// Remove customer allotment from CA
export const removeCustomerAllotmentFromCA = async (caId, customerId) => {
  const response = await axios.delete(`/superadmin/cas/${caId}/allot-customers/${customerId}`);
  return response.data;
};

// Allot customers to CA
export const allotCustomersToCA = async (caId, customerIds) => {
  const response = await axios.post('/superadmin/cas/allot-customers', { caId, customerIds });
  return response.data;
};

// Get CA permissions
export const getCAPermissions = async (caId) => {
  const response = await axios.get(`/superadmin/cas/${caId}/permissions`);
  return response.data;
};

// Update CA permissions
export const updateCAPermissions = async (caId, permissions) => {
  const response = await axios.put(`/superadmin/cas/${caId}/permissions`, { permissions });
  return response.data;
};

// Get agent permissions
export const getAgentPermissions = async (agentId) => {
  const response = await axios.get(`/superadmin/agents/${agentId}/permissions`);
  return response.data;
};

// Update agent permissions
export const updateAgentPermissions = async (agentId, permissions) => {
  const response = await axios.put(`/superadmin/agents/${agentId}/permissions`, { permissions });
  return response.data;
};

// Get subadmin agent permissions
export const getSubadminAgentPermissions = async (subadminId) => {
  const response = await axios.get(`/superadmin/subadmins/${subadminId}/agent-permissions`);
  return response.data;
};

// Update subadmin agent permissions
export const updateSubadminAgentPermissions = async (subadminId, permissions) => {
  const response = await axios.put(`/superadmin/subadmins/${subadminId}/agent-permissions`, permissions);
  return response.data;
};

// Get subadmin customer permissions
export const getSubadminCustomerPermissions = async (subadminId) => {
  const response = await axios.get(`/superadmin/subadmins/${subadminId}/customer-permissions`);
  return response.data;
};

// Update subadmin customer permissions
export const updateSubadminCustomerPermissions = async (subadminId, permissions) => {
  const response = await axios.put(`/superadmin/subadmins/${subadminId}/customer-permissions`, permissions);
  return response.data;
};

// Get CA customer permissions
export const getCACustomerPermissions = async (caId) => {
  const response = await axios.get(`/superadmin/cas/${caId}/customer-permissions`);
  return response.data;
};

// Update CA customer permissions
export const updateCACustomerPermissions = async (caId, permissions) => {
  const response = await axios.put(`/superadmin/cas/${caId}/customer-permissions`, permissions);
  return response.data;
};

//ITR status and OTp Update
export const updateITRstatusAndOtp = async (itrId, documentFile = null) => {
  const formData = new FormData();

  if (documentFile) {
    formData.append('document', documentFile);
  }

  const response = await axios.put(`/superadmin/otp-check/${itrId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updatefileCharge = async (agentId, fileCharge) => {
  const response = await axios.put(`/superadmin/agents/${agentId}/file-charge`, { fileCharge });
  return response.data;
}

export const assignCAtoITR = async (itrId, caId) => {
  const response = await axios.put(`/superadmin/assign-ca/${itrId}`, { caId });
  return response.data;
};

export const assignSubadmintoITR = async (itrId, subadminId) => {
  const response = await axios.put(`/superadmin/assign-subadmin/${itrId}`, { subadminId });
  return response.data;
};

export const deleteITRDocument = async (itrId, fieldName) => {
  const response = await axios.delete(`/superadmin/itr/${itrId}/document/${fieldName}`);
  return response.data;
};

export const uploadITRDocument = async (itrId, fieldName, file) => {
  const formData = new FormData();
  formData.append('document', file);
  const response = await axios.put(`/superadmin/itr/${itrId}/document/${fieldName}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const rejectITR = async (itr_id, reason, extra_charge) => {
  const response = await axios.post('/superadmin/reject-itr', { itr_id, reason, extra_charge });
  return response.data;
};

export const getITRFlowHistory = async (itrId) => {
  const response = await axios.get(`/superadmin/itr-flow/${itrId}`);
  return response.data;
};

export const getSubadminItrPermissions = async (subadminId) => {
  const response = await axios.get(`/superadmin/subadmins/${subadminId}/itr-permissions`);
  return response.data;
};

export const toggleSubadminItrPermission = async (subadminId, field) => {
  const response = await axios.post(`/superadmin/subadmins/${subadminId}/itr-permissions/toggle`, { field });
  return response.data;
};

export const undoRejectITR = async (itrId) => {
  const response = await axios.post(`/superadmin/undo-reject-itr/${itrId}`);
  return response.data;
};

export const getITRHistory = async (itrId) => {
  const response = await axios.get(`/payment/itr-history/${itrId}`);
  return response.data;
};

export const updateITR = async (itrId, data) => {
  const response = await axios.put(`/superadmin/itrs/${itrId}`, data);
  return response.data;
};

export const importAgents = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post('/superadmin/import-agents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getGlobalSearch = async (query) => {
  const response = await axios.get(`/superadmin/global-search?q=${encodeURIComponent(query)}`);
  return response.data;
};